import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class ScheduleService {

  constructor(
    private _http: HttpClient,
    private _capEngineService: CapabilityEngineService,
  ) { }

  gettingUsers(pageNumber) {
    let header = this._capEngineService.getHeaders('viewUserList');
    return this._http.get(environment.serverUrl + '/team/users/pagination/' + pageNumber, header);
}

updateUserDetails(obj) {
    return this._http.put(environment.serverUrl + '/user', obj);
}
gettingInspectionTemplate(pageNumber) {
    let header: any = this._capEngineService.getHeaders('viewTaskTemplateList');
    header.params = {
        category: 'inspection'
    };
    return this._http.get(environment.serverUrl + '/taskTemplate/pagination/' + pageNumber, header);
}
createSchedule(scheduleObj) {
    return this._http.post(environment.serverUrl + '/schedules', scheduleObj);
}

getAllSchedule() {
    let header = this._capEngineService.getHeaders('viewTaskTemplateList');
    return this._http.get(environment.serverUrl + '/schedules' , header);
}

deleteSchedule(scheduleId) {
    let header = this._capEngineService.getHeaders('viewTaskTemplateList');
    return this._http.delete(environment.serverUrl + '/schedules/' + scheduleId , header);
}

}



// WEBPACK FOOTER //
// ./src/app/schedule/schedule.service.ts